export class LoadingStart {
    public static readonly type = '[RootState] Start loading';
}
